import { render } from "./add_dental_procedures_modal.vue?vue&type=template&id=a7b48318&scoped=true"
import script from "./add_dental_procedures_modal.vue?vue&type=script&lang=js"
export * from "./add_dental_procedures_modal.vue?vue&type=script&lang=js"

import "./add_dental_procedures_modal.vue?vue&type=style&index=0&id=a7b48318&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b48318"]])

export default __exports__